import copy from 'copy-to-clipboard';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import CopyLinkIcon from '../../../static/icons/copy-link.svg';
import FacebookIcon from '../../../static/icons/facebook-color.svg';
import TwitterIcon from '../../../static/icons/twitter-color.svg';
import QATags from '../../constants/QATags';
import { COPY, FACEBOOK, messages, TWITTER } from '../../constants/ShareModal';

import ShareOption from './ShareOption';

import './ShareOptions.scss';

class ShareOptions extends React.Component {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    onSocialClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    shareSourcePath: PropTypes.string.isRequired,
    showShareCoachmark: PropTypes.func,
  };

  onFacebookClick = () => {
    this.props.onSocialClick(FACEBOOK);
  };

  onTwitterClick = () => {
    this.props.onSocialClick(TWITTER);
  };

  onCopyClick = () => {
    const {
      intl: { formatMessage: t },
    } = this.props;
    copy(this.props.shareSourcePath);
    this.props.showShareCoachmark(t(messages.linkCopied));
    this.props.onSocialClick(COPY);
    this.props.onClose();
  };

  render() {
    return (
      <div className='ShareOptions'>
        <ShareOption
          onClick={this.onFacebookClick}
          helperTextObj={messages.postTo}
          displayTextObj={messages.facebook}
          icon={FacebookIcon}
          qaTag={QATags.SMSBF}
        />
        <ShareOption
          onClick={this.onTwitterClick}
          helperTextObj={messages.postTo}
          displayTextObj={messages.twitter}
          icon={TwitterIcon}
          qaTag={QATags.SMSBT}
        />
        <ShareOption
          onClick={this.onCopyClick}
          displayTextObj={messages.copyLink}
          icon={CopyLinkIcon}
          qaTag={QATags.SMSB}
        />
      </div>
    );
  }
}

export default injectIntl(ShareOptions);
